// extracted by mini-css-extract-plugin
export default {"compensation-header":"Header_compensation-header__7UPZQ"};